import { Environment } from '../config/environment';
import { AdultType, ExtraDataType, QueryParam } from './models/Shared.types';
import { Backend } from './Backend';
import { IAssetV5, IBundleV5, ICategoryV5, INextAssetV5, IRibbon2Container } from './models/AndromeTV.types';
import { CmsFilterData } from '../Business/cms/actions/CmsFilterTypes';
import { EpisodesParam } from './VodApi.types';

export interface ProductionYearFilter extends QueryParam {
  categoryTag?: string[];
  catalogId?: string;
  adult?: AdultType;
}

interface VodCategoryFilter extends QueryParam {
  catalogId?: string;
}

export class VodApi {
  static asset(backend: Backend, vodId: string): Promise<IAssetV5> {
    const url = backend.makeUrl(`vod/v5/vod/${encodeURIComponent(vodId)}`);
    return backend.getJson(url, backend.bearer) as Promise<IAssetV5>;
  }

  /**
   * Get season assets
   */
  static assetSeasons(backend: Backend, vodId: string): Promise<IAssetV5[]> {
    const url = backend.makeUrl(`vod/v5/vod/${encodeURIComponent(vodId)}/season`);
    return backend.getJson(url, backend.bearer) as Promise<IAssetV5[]>;
  }

  /**
   * Get episode assets of a specific season
   */
  static seasonEpisodes(backend: Backend, seasonId: string): Promise<IAssetV5[]> {
    const url = backend.makeUrl(`vod/v5/vod/${encodeURIComponent(seasonId)}/episode`);
    return backend.getJson(url, backend.bearer) as Promise<IAssetV5[]>;
  }

  /**
   * Retrieve production years for the specified filter
   */
  static productionYears(backend: Backend, filter: ProductionYearFilter): Promise<number[]> {
    const url = backend.makeUrl('vod/v5/vod-production-year', filter);
    return backend.getJson(url, backend.bearer) as Promise<number[]>;
  }

  /**
   * Retrieve vod categories
   */
  static vodCategories(backend: Backend, filter: VodCategoryFilter): Promise<ICategoryV5[]> {
    const url = backend.makeUrl('vod/v5/vod-category', filter);
    return backend.getJson(url, backend.bearer) as Promise<ICategoryV5[]>;
  }

  static vodFilterUrl(backend: Backend, filter: CmsFilterData) {
    const queryParam: QueryParam = {
      platformType: Environment.system,
      catalogId: backend.deviceProfile?.profile.catalog,
      extraData: ExtraDataType.MINI,
      sortBy: 'TITLE',
      sortDir: 'ASC',
      adult: AdultType.False,
    };
    if (filter.category) {
      queryParam.categoryTag = filter.category.value.filter((x: string) => x !== '*');
    }
    if (filter.year) {
      queryParam.productionYear = filter.year.value;
    }
    if (filter.rating) {
      queryParam.minOperatorScore = filter.rating.value[0];
      queryParam.maxOperatorScore = filter.rating.value[1];
    }
    return backend.makeUrl('vod/v5/cms/vod', queryParam) + '&' + 'page=${page}';
  }

  static nextAsset(
    backend: Backend,
    vodId: string,
    catalogId?: string,
    adult = AdultType.False
  ): Promise<INextAssetV5> {
    const queryParam: QueryParam = {
      adult,
    };
    if (catalogId) queryParam.catalogId = catalogId;
    const url = backend.makeUrl(`vod/v5/vod/${encodeURIComponent(vodId)}/next-asset`, queryParam);
    return backend.getJson(url, backend.bearer) as Promise<INextAssetV5>;
  }

  /**
   * get bundle details
   */
  static bundle(backend: Backend, bundleId: string): Promise<IBundleV5> {
    const url = backend.makeUrl(`vod/v5/bundle/${encodeURIComponent(bundleId)}`);
    return backend.getJson(url, backend.bearer) as Promise<IBundleV5>;
  }

  /**
   * Get episodes in cms format season/series id
   */
  static episodes(backend: Backend, id: string, param: EpisodesParam): Promise<IRibbon2Container> {
    const url = backend.makeUrl(`vod/v5/cms/${id}/episode`, param);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container>;
  }
}

// https://tv-api.dev.nebula.androme.com/api/vod/v2/cms/vod?
// https://tv-api.dev.nebula.androme.com/api/vod/v2/cms/vod?
// https://tv-api.dev.nebula.androme.com/api/vod/v5/cms/vod?categoryTag=movies&categoryTag=family&categoryTag=disney&page=0&platformType=SMARTTV_TIZEN&extraData=NONE&sortBy=TITLE&sortDir=ASC
// https://tv-api.dev.nebula.androme.com/api/vod/v5/cms/vod?page=0&platformType=SMARTTV_TIZEN&catalogId=99fa2284-7c37-4bc8-b864-000000000001&extraData=NONE&sortBy=TITLE&sprtDir=ASC&categoryTag=movies&categoryTag=family&categoryTag=disney
